// extracted by mini-css-extract-plugin
export default {"content":"ShowItems_content__QwxBf","space":"ShowItems_space__D8fwk","cards":"ShowItems_cards__KBRYr","card":"ShowItems_card__L4ePu","fields":"ShowItems_fields__RGSGX"};